module.exports = __webpack_public_path__ + "img/success.3360ac4d.svg";